import { api } from '../api';

export const getParticipantsNamesFromAppointment = async (
  appointmentId: string,
): Promise<{
  patientName: string;
  professionalName: string;
}> => {
  // Instância `api` (sessão do usuário), e não mais a `apiTwilioRecordings`:
  // a rota deixou de ser M2M na tarefa 0.20 do roadmap B2G e passou a exigir
  // `Bearer` + permissão `video_attendance`. O segredo do Twilio que esta chamada
  // enviava vinha de `REACT_APP_TWILIO_*` e o CRA o embutia no bundle — ficava
  // legível para qualquer usuário do portal, servindo uma rota que devolve nome de
  // paciente. As duas envs foram removidas.
  const {
    data: { participants },
  } = await api.get(`/recordings/participants/${appointmentId}`);

  return participants;
};
